/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
import cx from 'classnames';
import * as React from 'react';
import { IconButton } from '../Buttons/index.js';
import { useTheme, SvgMoreVertical } from '../utils/index.js';
import { DropdownMenu } from '../DropdownMenu/index.js';
const defaultTranslations = {
    moreOptions: 'More options',
};
/**
 * Application header
 * @example
 * <Header
 *  appLogo={<HeaderLogo logo={<SvgImodelHollow />}>iTwin Application</HeaderLogo>}
 *  breadcrumbs={
 *   <HeaderBreadcrumbs items={[
 *    <HeaderButton key='project' name='Project A' />
 *    <HeaderButton key='imodel' name='IModel X' />
 *   ]} />
 *  }
 *  actions={[
 *   <IconButton><SvgNotification /></IconButton>,
 *   <DropdownMenu>
 *    <IconButton>
 *     <SvgHelpCircularHollow />
 *    </IconButton>
 *   </DropdownMenu>,
 *   <DropdownMenu menuItems={...}>
 *    <IconButton styleType='borderless'>
 *     <Avatar ... />
 *    </IconButton>
 *   </DropdownMenu>
 *  ]}
 *  isSlim
 * />
 */
export const Header = (props) => {
    const { appLogo, breadcrumbs, isSlim = false, actions, userIcon, menuItems, translatedStrings, className, children, ...rest } = props;
    useTheme();
    const headerTranslations = { ...defaultTranslations, ...translatedStrings };
    return (React.createElement("header", { className: cx('iui-page-header', className), "data-iui-size": isSlim ? 'slim' : undefined, ...rest },
        React.createElement("div", { className: 'iui-page-header-left' },
            appLogo,
            breadcrumbs && React.createElement("div", { className: 'iui-page-header-divider' }),
            breadcrumbs),
        children && React.createElement("div", { className: 'iui-page-header-center' }, children),
        React.createElement("div", { className: 'iui-page-header-right' },
            actions,
            userIcon,
            menuItems && (React.createElement(DropdownMenu, { menuItems: menuItems },
                React.createElement(IconButton, { styleType: 'borderless', "aria-label": headerTranslations.moreOptions },
                    React.createElement(SvgMoreVertical, { "aria-hidden": true })))))));
};
export default Header;
